var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"form-group observaciones",attrs:{"xs12":""}},[_c('vue-editor',{attrs:{"editor-options":_vm.editorSettings},on:{"change":_vm.observaciones},model:{value:(_vm.valueComputed),callback:function ($$v) {_vm.valueComputed=$$v},expression:"valueComputed"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc33cef6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/talento/TalentoObservaciones.vue
// module id = null
// module chunks = 